
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useTranslateText } from '@/modules/translation/model/translate';
import { ROUTE_NAME_TRANSLATION } from '@/modules/translation/router';

export default defineComponent({
    name: ROUTE_NAME_TRANSLATION.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { v$, model, localeSupportedOptions, fetch, beforeFetch, actions } = useTranslateText();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, localeSupportedOptions, fetch, actions };
    }
});
